module.exports = __webpack_public_path__ + "static/media/corner_white.6327da9e.svg";